import { useAppDispatch, useAppSelector } from "app/hooks";
import { useRbac } from "features/rbac/rbac";
import { ERbacPermissions } from "features/rbac/rbacPermissionsList";
import { actions } from "models/Slices/FilterSlice";
import React, { useEffect } from "react";
import Kpis from "./KPIS/Kpis";
import ListingAlerts from "./ListingAlerts/ListingAlerts";
import { dataSource } from "models/Slices/GlobalSlice";

const InventoryTrading: React.FC = () => {

  const dispatch = useAppDispatch();
  const { hasPermissions } = useRbac();
  const DataSource = useAppSelector(dataSource)

  useEffect(() => {
    dispatch(actions.getAllStatesData({ env: DataSource }));
    if (hasPermissions([ERbacPermissions.FILTER_BROKER_USER_SELECTION_ALL])) {
      dispatch(actions.getBrokerUserData({ env: DataSource }));
    }

    if (
      hasPermissions([
        ERbacPermissions.FILTER_LISTER_USER_SELECTION_ALL,
        ERbacPermissions.FILTER_LISTER_USER_SELECTION_TEAM,
      ])
    ) {
      dispatch(actions.getListerUserData({ env: DataSource }));
    }
  }, []);

  return (
    <React.Fragment>
      <ListingAlerts/>
      <Kpis />
    </React.Fragment>

  );
};

export default InventoryTrading;
